import { render, staticRenderFns } from "./AcceptanceContactIfNeutral.vue?vue&type=template&id=c8ccb83c&"
import script from "./AcceptanceContactIfNeutral.vue?vue&type=script&lang=ts&"
export * from "./AcceptanceContactIfNeutral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports